import { useToken } from '@chakra-ui/react';

import { PopoverContent, VStack } from '@frontend/components';

import { FindingContent } from './FindingContent';
import type { FindingData } from './types';

type FindingPopoverBodyProps = {
  finding: FindingData;
  headerActions?: React.ReactNode;
  actionSlot?: React.ReactNode;
  footerSlot?: React.ReactNode;
  additionalContent?: React.ReactNode;
  contentRef?: React.Ref<HTMLDivElement>;
  currentPartFileUuid?: string | null;
  showProvenance?: boolean;
};

export const FindingPopoverBody = ({
  contentRef,
  footerSlot,
  ...rest
}: FindingPopoverBodyProps) => {
  const [footerArrowBg] = useToken('colors', ['page.background']);

  return (
    <PopoverContent
      ref={contentRef}
      rootProps={
        footerSlot
          ? {
              sx: {
                // Placement top*: popover is above the trigger, arrow on the bottom edge.
                // Match the footer stripe (page.background) instead of page.surface.
                '&[data-popper-placement^="top"] .chakra-popover__content': {
                  '--popper-arrow-bg': footerArrowBg,
                },
              },
            }
          : undefined
      }
    >
      <VStack alignItems="stretch" gap={0}>
        <FindingContent footerSlot={footerSlot} {...rest} />
      </VStack>
    </PopoverContent>
  );
};
